import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "./ui/button";

const NAV_ITEMS = [
  { label: "Inicio", path: "/" },
  { label: "Clientes", path: "/clientes" },
  { label: "Nuevo Cliente", path: "/nuevocliente" },
  { label: "Guardería", path: "/guarderia" },
  { label: "Movimientos", path: "/movimientos" },
  { label: "Detalles de Movimientos", path: "/detallesmovimientos" },
  { label: "Ingresos", path: "/registros" },
  { label: "Histórico", path: "/historico" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Configuración", path: "/ConfiguracionPage" },
  { label: "Videos", path: "/ayuda" },
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

  return (
    <>
      <nav className="bg-gradient-to-r from-azul-oscuro to-verde-esmeralda p-4 shadow-lg sticky top-0 z-40">
        <div className="container mx-auto flex justify-between items-center">
          {/* Logo y nombre */}
          <Link to="/" className="flex items-center space-x-2" onClick={closeMobileMenu}>
            <img src="/DRIZA_LOGO.png" alt="Driza Icon" className="h-14 w-auto" />
            {/*<span className="text-2xl font-bold text-blanco-puro" style={{ fontFamily: 'Baloo 2, cursive' }}>DRIZA</span>*/}
          </Link>

          {/* Links desktop */}
          <div className="hidden md:flex space-x-9">
            {NAV_ITEMS.map((item) => (
              <Link to={item.path} key={item.label}>
                <Button
                  variant="ghost"
                  className="hover:bg-amarillo-dorado hover:text-azul-oscuro text-blanco-puro transition-colors duration-300 focus:ring-2 focus:ring-offset-2 focus:ring-blanco-puro"
                >
                  {item.label}
                </Button>
              </Link>
            ))}
          </div>

          {/* Botón hamburguesa mobile */}
          <button
            type="button"
            className="md:hidden text-blanco-puro text-3xl leading-none p-2"
            aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
        </div>
      </nav>

      {/* Overlay mobile */}
      {isMobileMenuOpen && (
        <button
          type="button"
          className="fixed inset-0 bg-black/60 z-40 md:hidden"
          aria-label="Cerrar menú móvil"
          onClick={closeMobileMenu}
        />
      )}

      {/* Sidebar / drawer mobile */}
      <aside
        className={`fixed top-0 right-0 h-dvh w-72 max-w-[85vw] bg-azul-oscuro shadow-2xl z-50 transform transition-transform duration-300 md:hidden flex flex-col ${
          isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!isMobileMenuOpen}
      >
        <div className="flex items-center justify-between p-4 border-b border-blanco-puro/20">
          <span className="text-blanco-puro font-semibold">Menú</span>
          <button
            type="button"
            className="text-blanco-puro text-2xl leading-none"
            aria-label="Cerrar menú"
            onClick={closeMobileMenu}
          >
            ✕
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto p-4 space-y-2">
          {NAV_ITEMS.map((item) => (
            <Link to={item.path} key={item.label} onClick={closeMobileMenu}>
              <Button
                variant="ghost"
                className="w-full justify-start text-left whitespace-normal break-words py-3 hover:bg-amarillo-dorado hover:text-azul-oscuro text-blanco-puro transition-colors duration-300"
              >
                {item.label}
              </Button>
            </Link>
          ))}
        </div>
      </aside>
    </>
  );
};

export default Navbar;
